import React from "react";
import Button from "./Button";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const buttonNameList = [
  "All",
  "Live",
  "Programming",
  "Gaming",
  "Songs",
  "Comedy",
  "Politics",
  "Thriller",
  "Mixes",
  "Cricket",
  "Cooking",
  "Football",
  "Upcomming",
];
const ButtonList = () => {
  return (
    <div className="flex gap-2.5 m-5 sticky top-[4.2rem] bg-white max-xl:hidden">
      <button className="px-2 py-2  rounded-lg">
        <FiChevronLeft />
      </button>
      <div className=" flex gap-2 w-[91%] overflow-hidden" style={{}}>
        {buttonNameList.map((eachButton, index) => {
          if (index > 11) return null;
          return <Button key={index} buttonName={`${eachButton}`} />;
        })}
      </div>
      <div className=" absolute right-[10px] pl-5 my-2  bg-gradient-to-r to-45% from-gray-200">
        <button className="px-2 py-2  rounded-lg">
          <FiChevronRight />
        </button>
      </div>
    </div>
  );
};

export default ButtonList;
